import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

/**
 * CheckoutCardHeaderComponent
 *
 * Header component for checkout card.
 * Displays the activity/resource name with a menu trigger for actions.
 *
 * Inputs:
 * - title: Activity or resource name to display
 * - menuItems: Optional menu items configuration (handled by parent component)
 *
 * Example:
 * <app-checkout-card-header
 *   title="Indendørs fodbold"
 *   #menu="matMenu">
 * </app-checkout-card-header>
 */
@Component({
  selector: 'app-checkout-card-header',
  imports: [MatIconModule, MatButtonModule, MatMenuModule],
  templateUrl: './checkout-card-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './checkout-card-header.component.scss',
})
export class CheckoutCardHeaderComponent {
  /**
   * Title to display in the header (activity/resource name)
   */
  title = input<string>('');

  hasMenu = input<boolean>(false);
  /**
   * When the inline actions (`[card-header-action]`) replace the ⋮ menu: `wide` from a 360px header,
   * `compact` from 240px — for a narrow card with a couple of icons, like the basket's.
   */
  inlineActionsFrom = input<'wide' | 'compact'>('wide');

  size = input<'small' | 'large'>('large'); // if content which belongs to the header has actionable content use "large"
}
